export default __webpack_public_path__ + "static/media/mauquenchymini.f470b970.jpg";